export default "__VITE_ASSET__B0uP1qNT__"